module.exports = __webpack_public_path__ + "enigio.af0b85c35e053e49ae8f.svg";